import Image from 'next/image';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { FrontUserTicketService } from '@/lib/jp-api/requests';
import { isAuthenticated } from '@/lib/helper/is-authenticated';
import { CmsParams } from '@/lib/cms-params.type';
import { useTranslations } from '@/lib/hooks/useTranslations';

export const TicketBalance: React.FC<{ cmsParams: CmsParams; ticketId: string; ticketImage: string; ns: string }> = ({
  cmsParams,
  ticketId,
  ticketImage,
  ns = 'default',
}) => {
  const t = useTranslations(`JackpotPurchaseTickets`, ns);
  const [ticketBalance, setTicketBalance] = useState<number>(0);
  const isUserAuthenticated = isAuthenticated(cmsParams);

  useEffect(() => {
    if (!isUserAuthenticated) return;
    FrontUserTicketService.getV2FrontUserTicketTicketBalanceByTicketId({
      hostname: cmsParams.brand,
      language: cmsParams.language,
      ticketId: ticketId,
    }).then((data) => {
      setTicketBalance(data.ticketAmount);
    });
  }, [cmsParams, ticketId, isUserAuthenticated]);

  return (
    <div className="tickets-tools__label">
      <Image
        alt=""
        src={ticketImage}
        width={18}
        height={18}
      />
      <div dangerouslySetInnerHTML={{ __html: t('ticketBalance', { ticketBalance: ticketBalance }) }}></div>
    </div>
  );
};
